import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessStep = ({ number, icon, title, description, duration, deliverables }) => {
  return (
    <div className="relative">
      <div className="flex flex-col md:flex-row gap-4 md:gap-6">
        <div className="flex-shrink-0">
          <div className="relative">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary/10 border-2 border-primary flex items-center justify-center">
              <Icon name={icon} size={28} color="var(--color-primary)" />
            </div>
            <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-bold">
              {number}
            </div>
          </div>
        </div>

        <div className="flex-1">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3 md:mb-4 gap-2">
            <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground">
              {title}
            </h3>
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-muted rounded-full text-xs md:text-sm font-medium text-muted-foreground w-fit">
              <Icon name="Clock" size={14} />
              {duration}
            </span>
          </div>

          <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-6 leading-relaxed">
            {description}
          </p>

          <div className="space-y-2">
            <h4 className="text-sm font-bold text-foreground uppercase tracking-wider">
              Key Deliverables:
            </h4>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {deliverables?.map((item, index) => (
                <li key={index} className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />
                  <span className="text-sm md:text-base text-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessStep;